import { call, put } from 'redux-saga/effects';
import { validateVATNumberFailure, validateVATNumberSuccess } from '../actions';
import { ApiError } from 'store/api/types';
import { ValidateVATNumberRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { ValidateVATNumberResponse, validateVATNumber } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* validateVATNumberSaga(action: ValidateVATNumberRequestAction) {
  try {
    let err: ApiError | null;
    const { countryCode, taxNumber } = action.payload;

    const validateVATNumberResponse: ValidateVATNumberResponse = yield call(
      validateVATNumber,
      countryCode,
      taxNumber
    );

    err = checkResponse(validateVATNumberResponse?.responseMessage);
    if (err) throw err;

    yield put(
      validateVATNumberSuccess({
        isValid: validateVATNumberResponse?.data?.isValid === 'VALID',
        countryCode: countryCode,
        taxNumber: taxNumber,
      })
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(validateVATNumberFailure());
  }
}
